import api from '@/api'

export default {
  namespaced: true,
  state: {
    projects: [],
    search: '',
    show_search: false,
    page: 1,
    sizes: [5, 8, 12, 16, 18],
    loading: false,
    loading_suggestions: false,
    limit_reached: false,
    loaded_project: null,
    suggested_projects: []
  },
  getters: {
    list: function (state) {
      return state.projects
    },
    canLoad: function (state) {
      if (state.loading === false && state.limit_reached === false) {
        return true
      } else {
        return false
      }
    },
    batchSize: function (state, getters, rootState) {
      if (rootState.app.display === "xs") {
        return state.sizes[0]
      } else if (rootState.app.display === "sm") {
        return state.sizes[1]
      } else if (rootState.app.display === "md") {
        return state.sizes[2]
      } else if (rootState.app.display === "lg") {
        return state.sizes[3]
      } else {
        return state.sizes[4]
      }
    }
  },
  mutations: {
    toggle_search: function (state) {
      state.show_search = !state.show_search
    },
    show_search: function (state) {
      state.show_search = true
    },
    hide_search: function (state) {
      state.show_search = false
    },
    update_search: function (state, search) {
      state.search = search;
    },
    reset_search: function (state) {
      state.projects = []
      state.limit_reached = false
      state.show_search = false
      state.loading = false
      state.page = 1
    },
    add_projects: function (state, projects) {
      state.projects = state.projects.concat(projects)
    },
    project_loaded: function (state, project) {
      state.loaded_project = project
    },
    set_suggestions: function (state, data) {
      state.suggested_projects = data;
    },
    project_load_error: function () {
      alert("Error loading project")
    }
  },
  actions: {
    load_suggestions: async function (context) {
      context.state.loading_suggestions = true;
      let results = await api(`/projects/${context.state.loaded_project.id}/suggestions`);
      context.commit('set_suggestions', results)
      context.state.loading_suggestions = false;

    },
    load_project: async function (context, id) {
      id = parseInt(id)
      //see if we already have it in state
      context.state.loading = true
      let project = context.state.projects.find(p => {
        return p.id === id
      })
      if (project) {
        context.commit('project_loaded', project)
      } else {
        project = await api(`/projects/${id}`)
        if (project) {
          context.commit('project_loaded', project)
        }
      }
      context.dispatch('load_suggestions');
      context.state.loading = false
    },
    search: async function (context) {
      context.commit('reset_search')
      context.dispatch('load')

    },
    load: async function (context) {
      if (!context.getters.canLoad) {
        alert("Not allowed to load more")
      }
      context.state.loading = true
      let result = await api({
        method: 'GET',
        url: `/projects`,
        params: {
          search: context.state.search ? context.state.search : null,
          page: context.state.page,
          limit: context.getters['batchSize']
        }
      })
      if (result.length) {
        context.state.page += 1
        context.commit('add_projects', result)
      } else {
        context.state.limit_reached = true;
      }

      context.state.loading = false
    }
  }
}